import { useSyncExternalStore } from 'react';
import type { SectorKey } from './sectors';

// Tiny shared store so the variant's Nav can show story progress and the unit being followed.
export type StoryState = { sector: SectorKey; active: number; progress: number; inStory: boolean };

let state: StoryState = { sector: 'lift', active: 0, progress: 0, inStory: false };
const subs = new Set<() => void>();

export const storyStore = {
  get: () => state,
  set(patch: Partial<StoryState>) {
    const next = { ...state, ...patch };
    if (
      next.sector === state.sector &&
      next.active === state.active &&
      next.inStory === state.inStory &&
      Math.abs(next.progress - state.progress) < 0.002
    )
      return;
    state = next;
    subs.forEach((f) => f());
  },
  sub(f: () => void) {
    subs.add(f);
    return () => {
      subs.delete(f);
    };
  },
};

export const useStory = () => useSyncExternalStore(storyStore.sub, storyStore.get, storyStore.get);
